"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _View = require("./View");
Object.keys(_View).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _View[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _View[key];
    }
  });
});